import { Box } from '@mui/material';

export const Tag = ({ label }: { label: string }) => {
  return (
    <Box
      sx={{
        backgroundColor: 'primary.main',
        px: '4px',
        fontSize: '8px',
        textTransform: 'uppercase',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        lineHeight: 1,
        py: '2px'
      }}
    >
      <span> {label}</span>
    </Box>
  );
};
